import { render, staticRenderFns } from "./PosterContent.vue?vue&type=template&id=18e77f0a&scoped=true"
import script from "./PosterContent.vue?vue&type=script&lang=js"
export * from "./PosterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e77f0a",
  null
  
)

export default component.exports